/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Too_Many_RequestsInputs */

const en_us2_community_too_many_requests = /** @type {(inputs: Community_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many in a short time. Try again later.`)
};

const pt_br2_community_too_many_requests = /** @type {(inputs: Community_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas ações em pouco tempo. Tente de novo mais tarde.`)
};

const es_419_community_too_many_requests = /** @type {(inputs: Community_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiadas acciones en poco tiempo. Inténtalo de nuevo más tarde.`)
};

const pt_pt2_community_too_many_requests = /** @type {(inputs: Community_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiadas ações em pouco tempo. Tenta de novo mais tarde.`)
};

const fr_fr2_community_too_many_requests = /** @type {(inputs: Community_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop d'actions en peu de temps. Réessaie plus tard.`)
};

const de_de2_community_too_many_requests = /** @type {(inputs: Community_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viele Aktionen in kurzer Zeit. Versuch es später erneut.`)
};

const it_it2_community_too_many_requests = /** @type {(inputs: Community_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppe azioni in poco tempo. Riprova più tardi.`)
};

/**
* | output |
* | --- |
* | "Too many in a short time. Try again later." |
*
* @param {Community_Too_Many_RequestsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_too_many_requests = /** @type {((inputs?: Community_Too_Many_RequestsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Too_Many_RequestsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_too_many_requests(inputs)
	if (locale === "es-419") return es_419_community_too_many_requests(inputs)
	if (locale === "pt-PT") return pt_pt2_community_too_many_requests(inputs)
	if (locale === "fr-FR") return fr_fr2_community_too_many_requests(inputs)
	if (locale === "de-DE") return de_de2_community_too_many_requests(inputs)
	if (locale === "it-IT") return it_it2_community_too_many_requests(inputs)
	return en_us2_community_too_many_requests(inputs)
});
export { community_too_many_requests as "community.too_many_requests" }